<script>
    import { createEventDispatcher } from "svelte";

    export let titleClass = "",
        title = "",
        instanceId = "",
        config = {
            collapseArr: [
                {
                    title: "",
                    propertyName: "",
                    titleClass: "",
                    inputType: "text",
                    inputClass: "",
                    inputValue: "",
                },
            ],
        },
        onChange = () => {};

    const dispatch = createEventDispatcher();

    const handleInputChange = (propertyName, value) =>
        dispatch("collapseInputChange", { instanceId, propertyName, value });
</script>

<div class="flex w-full items-start gap-x-2">
    <p class={`w-[20%] pt-1 ${titleClass}`}>{title}</p>

    <div class="flex w-full items-center justify-between gap-2 flex-wrap">
        {#each config.collapseArr as collapse, i}
            <div class="flex items-center gap-x-2">
                <p class={collapse.titleClass}>{collapse.title}</p>
                {#if !collapse.inputType || collapse.inputType.toLowerCase() == "text"}
                    <input
                        class={`input input-sm input-bordered ${collapse.inputClass}`}
                        type="text"
                        bind:value={config.collapseArr[i].inputValue}
                        on:input={(e) =>
                            handleInputChange(
                                collapse.propertyName,
                                e.target.value,
                            )}
                    />
                {:else if collapse.inputType.toLowerCase() == "color"}
                    <input
                        class={collapse.inputClass}
                        type="color"
                        bind:value={config.collapseArr[i].inputValue}
                        on:input={(e) =>
                            handleInputChange(
                                collapse.propertyName,
                                e.target.value,
                            )}
                    />
                {/if}
            </div>
        {/each}
    </div>
</div>
